<template>
  <ul
    v-if="tag.tree"
    class="pb-tag-filter-list"
    :class="{ 'pb-tag-filter-list-root': root }"
  >
    <TagFilterItem
      v-for="tagName in Object.keys(tag.tree)"
      :key="tagName"
      :tag="tag.tree[tagName]"
      :link="routeName"
    />
  </ul>
</template>
<script setup>
import TagFilterItem from '@/components/TagFilterItem.vue'

defineProps({
  routeName: { type: String, required: true },
  tag: { type: Object, default: () => ({}) },
  root: { type: Boolean, default: true },
})
</script>

<style lang="scss">
@use 'sass:math';
@use '@nicolaudie-group/ng-ui-kit/defines/_fonts.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_colors.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_config.define.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_flexbox.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_generic.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_responsive.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_theme.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_animations.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_transitions.mixin.scss';

@use '/src/styles/_pb.scss';

.pb-tag-filter-list {
  width: 100%;
  box-sizing: border-box;

  .pb-link {
    display: flex;
    align-items: center;
  }

  .pb-link-active {
    font-weight: bold;
  }
}

.pb-tag-filter-item-name {
  flex-grow: 1;
}

.pb-tag-filter-item {
  list-style-type: none;
}

.pb-tag-filter-list-root > .pb-tag-filter-item {
  border: 1px solid colors.$color-default--gray-border;
  border-bottom: 0;
  background-color: white;
  padding: 3px;

  &:first-of-type {
    border-radius: 5px 5px 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 5px 5px;
    border-bottom: 1px solid colors.$color-default--gray-border;
  }
}

.pb-tag-filter-item {
  .pb-link {
    padding: 5px 10px;
    border-radius: 5px;

    &:hover, &:focus, &.pb-link-active {
      background-color: colors.$color-default--gray-back
    }
  }
}

.pb-tag-filter-item .pb-tag-filter-list {
  border-radius: 5px;
}

.pb-tag-filter-item .pb-tag-filter-item {
  margin-left: 20px;
}

</style>
